<template>
    <span>
      <b-card no-body>
        <b-card-header>
          <b-row>
            <b-col md="9">
              <h3 tabindex="0">Gerenciar Áreas</h3>
            </b-col>
            <b-col md="3">
              <b-button @click="navigate('/area/cadastrar')" block variant="primary">
                    <i class="fa fa-plus"></i>
                  <span>Nova Área</span>
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group label="Nome da Área">
                <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Título"></b-form-input>
              </b-form-group>
            </b-col>
             <b-col sm="2">
              <b-form-group label="Situação:">
                <b-form-select v-model="filtros.status" class="mb-3">
                    <option selected :value="null"> Selecione </option>
                    <option v-for="situacao in situacoes" :value="situacao.value" :key="situacao.value"> {{ situacao.text }} </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
              <b-button block @click="limpar">
                <i class="fa fa-eraser"></i>&nbsp;&nbsp;<span>Limpar filtros</span>
              </b-button>
            </b-col>
            <b-col sm="2">
              <b-button block variant="primary" @click="pesquisar">
                <i class="fa fa-search"></i>&nbsp;&nbsp;<span>Pesquisar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-header>
        <b-row>
          <b-col sm="12">
            <b-container fluid>
              <span>
                <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Id</th>
                      <th scope="col">Título da área</th>
                      <th scope="col">Status</th>
                      <th scope="col">Ações</th>
                    </tr>
                  </thead>

                  <tbody v-if="areas.data !== undefined">
                    <tr class="action" v-for="area in areas.data" :key="area.id">
                      <td>{{area.id}}</td>
                      <td>{{area.titulo}}</td>
                      <td>{{area.status == 0 ? 'Inativo' : 'Ativo'}}</td>
                      <td style="width: 15%">
                          <a class="btn btn-sm btn-secondary action" title="Editar" @click="editarArea(area.id)">
                            <i class="fa fa-pencil-square-o"></i>
                          </a>

                          <a class="btn btn-sm btn-secondary action" title="Visualizar" @click="visualizarArea(area.id)">
                            <i class="fa fa-search"></i>
                          </a>

                          <a v-if="area.status == 1" class="btn btn-sm btn-secondary action" title="Desativar" @click="alterarSituacao(area.id, 0)">
                            <i class="fa fa-toggle-off"></i>
                          </a>

                          <a v-if="area.status == 0" class="btn btn-sm btn-secondary action" title="Ativar" @click="alterarSituacao(area.id, 1)">
                            <i class="fa fa-toggle-on"></i>
                          </a>

                          <a class="btn btn-sm btn-secondary action" title="Excluir" @click="excluirArea(area.id)">
                            <i class="fa fa-trash"></i>
                          </a>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="action">
                      <td colspan="4">Nenhuma área cadastrada</td>
                    </tr>
                  </tbody>
                </table>
                <pagination v-show="areas.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"></pagination>
              </span>
            </b-container>
          </b-col>
        </b-row>
      </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import {DatePicker, setupCalendar} from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  created () {   
    // if (!this.validaPerfil()) {
    //   this.$router.push('/')
    // }
  },
  data () {
    return {
      totalPorPagina: 10,
      resource: 'areas',
      filtros: {
        filter: '',
        status: null
      },
      situacoes: [
        {value: '1', text: 'Ativo'},
        {value: '0', text: 'Inativo'}
      ],
    }
  },
  computed: {
    areas () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    }
  },
  methods: {
    validaPerfil () {
      let perfil = this.$store.state.perfil.perfil     
      if (perfil.is_admin_conferencia) {
        return true
      }
      return false
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    pesquisar () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
      this.setarFiltros(this.filtros)
    },
    editarArea (id) {
      this.$router.push('/area/editar/' + id)
    },
    visualizarArea (id) {
      this.$router.push('/area/visualizar/' + id)
    },
    excluirArea (id) {
      this.$bvModal.msgBoxConfirm('Deseja excluir a área selecionada?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.delete('api/areas/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    alterarSituacao (id, situacao){
      var msg = ''
      if(situacao > 0){
         msg = 'Deseja ativar a área selecionada?'
      }else{
         msg = 'Deseja desativar a área selecionada?'
      }

      this.$bvModal.msgBoxConfirm(msg, {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.post('api/areas/alterarSituacao', {id: id, status: situacao}).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success('Situação alterada com sucesso!', 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error('Erro ao alterar situação!', 'Alerta', 5000)
            }
            this.loading = false
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      })
    },
    navigate (route) {
      this.$router.push(route)
    },
    limpar () {
      this.filtros = {status: null, filter: ''}
      this.pesquisar()
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect.invalid .multiselect__tags,
    .multiselect.invalid .multiselect__tags span,
    .multiselect.invalid .multiselect__tags input {
        background:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/area/Areas.vue